/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'

/**
 *
 * @export
 * @interface EnvelopedPortfolioWorkCreate123Admin
 */
export interface EnvelopedPortfolioWorkCreate123Admin {
  /**
   *
   * @type {any}
   * @memberof EnvelopedPortfolioWorkCreate123Admin
   */
  body: any | null
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedPortfolioWorkCreate123Admin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedPortfolioWorkCreate123Admin interface.
 */
export function instanceOfEnvelopedPortfolioWorkCreate123Admin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedPortfolioWorkCreate123AdminFromJSON(
  json: any,
): EnvelopedPortfolioWorkCreate123Admin {
  return EnvelopedPortfolioWorkCreate123AdminFromJSONTyped(json, false)
}

export function EnvelopedPortfolioWorkCreate123AdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedPortfolioWorkCreate123Admin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: json['body'],
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedPortfolioWorkCreate123AdminToJSON(
  value?: EnvelopedPortfolioWorkCreate123Admin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: value.body,
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
